import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js"
flatpickr.localize(German)

window.addEventListener("load", function () {
    flatpickr(".flatpickr-datum", {
        showMonths: 1,
        dateFormat: "d.m.Y",
    });
}, false);

